export const SHOP = '/shop' as const
export const PRODUCTS = '/products' as const
export const CATEGORIES = '/categories' as const
export const COLORS = '/colors' as const
export const SIZES = '/sizes' as const
export const MATERIALS = '/materials' as const
export const ALL_ORDERS = '/all-orders' as const
export const MY_ORDERS = '/my-orders' as const
export const PAYMENT_CONFIRM = '/payment-confirm' as const
